import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ErrorBarService {

  constructor(private snackBar: MatSnackBar) { }

  showMessage(message: string): void {
    this.snackBar.open(message, undefined, {
      duration: undefined,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'custom-snackbar'
    });
  }

  handleError(error: Error): void {
    const message = error.message || '予期せぬエラーが発生しました。';
    this.snackBar.open(message, undefined, {
      duration: 5000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'custom-snackbar'
    });
  }
  showStatusNotification(controlId: string, status: number): void {
    let message = '';
    switch (status) {
      case 0:
        message = `${controlId}は非準拠と判定されました。`;
        break;
      case 1:
        message = `${controlId}を申請しました。`;
        break;
      case 3:
        message = `${controlId}は一部のみ準拠と判定されました。`;
        break;
      case 4:
        message = `${controlId}は準拠と判定されました。`;
        break;
      default:
        return; // Do nothing
    }
    this.snackBar.open(message, undefined, {
      duration: 7000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'custom-snackbar',
    });
  }
  clear(): void {
    this.snackBar.dismiss();
  }
}